export const isVercelProduction = process.env.VERCEL_ENV === 'production'

export const isVercelPreview = process.env.VERCEL_ENV === 'preview'

export const isVercelDevelopment = process.env.VERCEL_ENV === 'development'

export const isLocked = process.env.NEXT_PUBLIC_ENABLE_AUTH === 'true'

export const hasUpstashEnabled = process.env.UPSTASH_ENABLED === 'true'
